import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';
import SalesforceSyncControl from '../controls/SalesforceSyncControl';
import { FLAG } from '../../../constants/Constants';

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  textTitle: {
    marginBottom: "40px",
    textAlign: "left",
    fontWeight: 700
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  row: {
    marginBottom: "22px",
    width: "100%",
    boxSizing: "border-box",
  },

  sectionTitle: {
    fontSize: "16px",
    marginBottom: "14px",
    fontWeight: "bold",
    padding: "8px 0px 11px 0px",
    borderBottom: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left",
  },

  sectionText: {
    margin: 0,
    padding: 0,
    fontSize: "16px",
    maxWidth: "410px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left",
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  },
});

/**
 * フォローコールのみ注文の送信ダイアログ
 */
class SubmitFollowCallOrderDialog extends React.Component {
  state = {
    salesforceSyncFlag: false,
  }

  handleToggleSalesforceSyncFlag = (value) => {
    this.setState({
      salesforceSyncFlag: value,
    });
  };

  handleSubmit = () => {
    this.props.action({
      "salesforce_sync_flag" : this.state.salesforceSyncFlag ? FLAG.ON : FLAG.OFF
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        message={this.props.message}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="display1" className={classes.textTitle}>
          注文を送信します。よろしいですか？
        </Typography>
        <div className={classes.row}>
          <div className={classes.sectionTitle}>宛先部数</div>
          <p className={classes.sectionText}>{this.props.selectedCount}部</p>
        </div>
        <SalesforceSyncControl
          isExe={false}
          handleToggleSalesforceSyncFlag={this.handleToggleSalesforceSyncFlag}
        />
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.props.toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.handleSubmit}
            text='注文を送信'
            loading={this.props.isPosting}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

SubmitFollowCallOrderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  message: PropTypes.string,
  action: PropTypes.func.isRequired,
  selectedCount: PropTypes.number,
  isPosting: PropTypes.bool,
};

export default withStyles(styles)(SubmitFollowCallOrderDialog);


// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/SubmitFollowCallOrderDialog.jsx